import React from 'react';

export const Filters = ({
    children
}) => {
    function getItems(items) {
        return items.map((item, index) => (
            <li key={`${item.key}-${index}`} className="filter-tags__item">
                { item }
            </li>
        ));
    }

    return (
        <div className="filter-tags">
            <ul className="filter-tags__list">
                {getItems(children)}
            </ul>
        </div>
    );
};
